import { render, staticRenderFns } from "./DocumentsHome.vue?vue&type=template&id=fb009206&scoped=true"
import script from "./DocumentsHome.vue?vue&type=script&lang=js"
export * from "./DocumentsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb009206",
  null
  
)

export default component.exports